var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo45C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "86px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_45c") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.2080757,55.9654403 C34.5077257,55.6670914 34.9921759,55.6670914 35.2918259,55.9654403 L38.2372178,58.8980426 C38.5388353,59.2009275 38.5378077,59.6871971 38.2372519,59.9864853 L37.352257,60.8677476 C37.0506585,61.1706514 37.0517166,61.656921 37.3522911,61.9561904 L53.5964823,78.1298456 C53.8961323,78.4281945 54.3805825,78.4281945 54.6802325,78.1298456 L70.9243978,61.9562162 C71.2260267,61.6532912 71.224976,61.1670217 70.924406,60.8677477 L70.0393269,59.9864852 C69.7377026,59.6835556 69.7387607,59.1972861 70.0393352,58.8980167 L72.9847011,55.9654403 C73.2843512,55.6670914 73.7688013,55.6670914 74.0684513,55.9654403 L78.9920424,60.8676519 C79.293675,61.1705897 79.2926169,61.6568592 78.9920424,61.9561286 L54.6801386,86.1624645 C54.3804886,86.4608134 53.8960384,86.4608134 53.5963884,86.1624645 L29.2844846,61.9561286 C28.9828521,61.6531909 28.9839101,61.1669213 29.2844846,60.8676519 Z M54.7062841,36.8429535 L71.2478857,53.3127277 C71.5495183,53.6156654 71.5484602,54.101935 71.2478857,54.4012043 L54.7062841,70.8709786 C54.406634,71.1693275 53.9221839,71.1693275 53.6225338,70.8709786 L37.0809322,54.4012043 C36.7792997,54.0982666 36.7803577,53.6119971 37.0809322,53.3127277 L53.6225338,36.8429535 C53.9221839,36.5446046 54.406634,36.5446046 54.7062841,36.8429535 Z M53.6225338,44.8755724 L45.1485828,53.3127277 C44.8469502,53.6156654 44.8480082,54.101935 45.1485828,54.4012043 L53.6225338,62.8383596 C53.9221839,63.1367085 54.406634,63.1367085 54.7062841,62.8383596 L63.1802352,54.4012043 C63.4818677,54.0982666 63.4808097,53.6119971 63.1802352,53.3127277 L54.7062841,44.8755724 C54.406634,44.5772235 53.9221839,44.5772235 53.6225338,44.8755724 Z M54.6801386,21.3177662 L78.9920424,45.5241021 C79.2926169,45.8233715 79.293675,46.3096411 78.9944056,46.6102156 L74.0684513,51.5147905 C73.7688013,51.8131394 73.2843512,51.8131394 72.9847011,51.5147905 L70.0393352,48.582214 C69.7387607,48.2829446 69.7377026,47.7966751 70.036972,47.4961006 L70.924406,46.612483 C71.224976,46.3132091 71.2260267,45.8269395 70.9267528,45.5263695 L54.6802325,29.3503852 C54.3805825,29.0520363 53.8961323,29.0520363 53.5964823,29.3503852 L37.3522911,45.5240404 C37.0517166,45.8233097 37.0506585,46.3095793 37.3499279,46.6101538 L38.2372519,47.4937455 C38.5378077,47.7930336 38.5388353,48.2793033 38.2395471,48.579859 L35.2918259,51.5147905 C34.9921759,51.8131394 34.5077257,51.8131394 34.2080757,51.5147905 L29.2844846,46.6125788 C28.9839101,46.3133094 28.9828521,45.8270399 29.2821214,45.5264654 L53.5963884,21.3177662 C53.8960384,21.0194173 54.3804886,21.0194173 54.6801386,21.3177662 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-34, -402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_45c",
    transform: "translate(28, 396)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#0E1C39",
    transform: "translate(53.7401, 53.7401) rotate(45) translate(-53.7401, -53.7401)",
    x: 15.7401154,
    y: 15.7401154,
    width: 76,
    height: 76,
    rx: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo45C);
export default __webpack_public_path__ + "static/media/logo_45c.89d89858e0713152542420098a3aacad.svg";
export { ForwardRef as ReactComponent };